import type { AuthState } from './types';

/**
 * Initial authentication state
 */
export const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};
